import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-index-pane iodine-scrollable-y full-width" }
const _hoisted_2 = { class: "iodine-padding-md reference-index-container" }

import ReferencesSearch from 'components/references/ReferencesSearch.vue';
import ReferencesBrowse from 'components/references/ReferencesBrowse.vue';
import { useTrucodeReferenceStore } from 'stores/references-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesIndex',
  setup(__props) {

const store = useTrucodeReferenceStore();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(ReferencesBrowse, null, null, 512), [
        [_vShow, _unref(store).getMode === 'browse']
      ]),
      _withDirectives(_createVNode(ReferencesSearch, null, null, 512), [
        [_vShow, _unref(store).getMode === 'search']
      ])
    ])
  ]))
}
}

})